// Note: This is dummy data for Flow Stream Mappings
// API: GET /flow/streams/{id}/mappings
// API: PUT /flow/streams/{id}/mappings - for initial mapping and update mapping

import { FeeNature } from "../enums/FeeNature";

// There's two exports - View and New
// export const useDummyStreamMappings = 'new'; // false OR 'new' OR 'view'
// export const useDummyStreamMappings = 'view'; // false OR 'new' OR 'view'
export const useDummyStreamMappings = false; // false OR 'new' OR 'view'

/**
 * Key explained:
 *
 * is_initialised (in stream): boolean  - If true: settings has already been initialised (ie: has start_sync_at) [applies for oAuth2 eg Lazada]
 * xx_allow_update: boolean - If true:
 *                              - label (name) will be an input field
 *                              - delete button will be shown
 *                              - Can add new mapping group row
 *                          - If false:
 *                             - label (name) will be a text
 *                             - delete button will be hidden
 *                             - Cannot add new mapping group row
 * xx_are_required: boolean - If true: mapping cannot be empty when update.
 * locations: array - Array of locations
 * tax_codes: array - Array of tax codes
 * payment_methods: array - Array of payment methods
 * fee_mappings: array - Array of fee mappings
 */
export const flowStreamMappingsView = {

    stream: {
        id: 36,
        flow_provider: {
            id: 1,
            name: "Storehub POS [DUMMY]",
            short_name: "storehub",
            authentication: "HTTP_BASIC",
        },
        ext_name: "Storehub [DUMMY]",
        auto_sync: 1,
        auto_create_invoice: 0,
        grouping: "ALL",
        sync_starts_at: "2024-01-10 00:00:00",
        sync_ends_at: "2024-01-24 23:59:59",
        // can_sync: true,
        created_at: "2024-01-31 09:30:33",
        updated_at: "2024-01-31 09:51:04",
        deleted_at: null,
        is_initialised: true,

    },

    locations_allow_update: false,
    locations_are_required: true,
    locations: [
        {
            id: 1,
            ext_id: 'storehub_location_1',
            name: 'Store A',
            location_id: 1,
            contact_id: 1,
            number_format_id: 1,
        },
        {
            id: 2,
            ext_id: 'storehub_location_2',
            name: 'Store B',
            location_id: 2,
            contact_id: 2,
            number_format_id: 2,
        },
        // Add more locations as needed
    ],
    tax_codes_allow_update: true,
    tax_codes_are_required: false, // can pass empty array
    tax_codes: [
        {
            id: 1,
            ext_id: 'tax_code_1',
            name: 'Tax Code 1',
            tax_code_id: 1,
        },
        {
            id: 2,
            ext_id: 'tax_code_2',
            name: 'Tax Code 2',
            tax_code_id: 2,
        },
        // Add more tax codes as needed
    ],
    payment_methods_allow_update: true,
    payment_methods_are_required: true,
    payment_methods: [
        {
            id: 1,
            ext_id: 'payment_method_cash',
            name: 'Cash',
            payment_method_id: 1,
        },
        {
            id: 2,
            ext_id: 'payment_method_credit_card',
            name: 'CreditCard',
            payment_method_id: 2,
        },
        {
            id: 3,
            ext_id: 'payment_method_debit_card',
            name: 'DebitCard',
            payment_method_id: 3,
        },
        // Add more payment methods as needed
    ],
    fee_mappings_allow_update: false,
    fee_mappings_are_required: true,
    fee_mappings: [
        {
            id: 111,
            ext_id: 1, // from Flow Providers' fee_types id
            name: "Sales",
            account_id: 21, // Mapping (bukku account id)
            flow_fee_type: {
                id: 1,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 112,
            ext_id: 2, // from Flow Providers' fee_types id
            name: "Discount",
            account_id: 74, // Mapping (bukku account id)
            flow_fee_type: {
                id: 2,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 113,
            ext_id: 3, // from Flow Providers' fee_types id
            name: "Service Charges",
            account_id: 66, // Mapping (bukku account id)
            flow_fee_type: {
                id: 3,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 114,
            ext_id: 4, // from Flow Providers' fee_types id
            name: "Rounding",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 4,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 115,
            ext_id: 5, // from Flow Providers' fee_types id
            name: "Sales Refund",
            account_id: 20, // Mapping (bukku account id)
            flow_fee_type: {
                id: 5,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 116,
            ext_id: 6, // from Flow Providers' fee_types id
            name: "Discount Refund",
            account_id: 12, // Mapping (bukku account id)
            flow_fee_type: {
                id: 6,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: 117,
            ext_id: 7, // from Flow Providers' fee_types id
            name: "Service Charges Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 7,
                nature: FeeNature.EXPENSE,
            },
        },
        {
            id: 118,
            ext_id: 8, // from Flow Providers' fee_types id
            name: "Rounding Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 8,
                nature: FeeNature.EXPENSE,
            },
        },
        {
            id: 119,
            ext_id: 9, // from Flow Providers' fee_types id
            name: "Tax (Dummy",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 8,
                nature: FeeNature.TAX,
            },
        },
    ],
};

export const flowStreamMappingsNew = {

    stream: {
        id: 36,
        flow_provider: {
            id: 1,
            name: "Storehub POS [DUMMY]",
            short_name: "storehub",
            authentication: "HTTP_BASIC",
        },
        ext_name: "Storehub [DUMMY]",
        auto_sync: 1,
        auto_create_invoice: 0,
        grouping: "ALL",
        sync_starts_at: "2024-01-10 00:00:00",
        sync_ends_at: "2024-01-24 23:59:59",
        // can_sync: false,
        created_at: "2024-01-31 09:30:33",
        updated_at: "2024-01-31 09:51:04",
        deleted_at: null,
        is_initialised: true,

    },

    locations_allow_update: false,
    locations_are_required: true,
    locations: [
        {
            id: null,
            ext_id: 'storehub_location_1',
            name: 'Store A',
            location_id: null, // Bukku Mapping
            contact_id: null,
            number_format_id: null,
        },
        {
            id: null,
            ext_id: 'storehub_location_2',
            name: 'Store B',
            location_id: null, // Bukku Mapping
            contact_id: null,
            number_format_id: null,
        },
        // Add more locations as needed
    ],

    tax_codes_allow_update: true,
    tax_codes_are_required: false, // can pass empty array
    tax_codes: [],

    payment_methods_allow_update: true,
    payment_methods_are_required: true,
    payment_methods: [
        {
            id: null,
            ext_id: 'payment_method_cash_zcbi1298',
            name: 'Cash',
            account_id: null, // Mapping (bukku account id)
        },
        {
            id: null,
            ext_id: 'payment_method_credit_card_sni1802',
            name: 'CreditCard',
            account_id: null, // Mapping (bukku account id)
        },
        {
            id: null,
            ext_id: 'payment_method_debit_card_cqb1282',
            name: 'DebitCard',
            account_id: null, // Mapping (bukku account id)
        },
        // Add more payment methods as needed
    ],

    fee_mappings_allow_update: false,
    fee_mappings_are_required: true,
    fee_mappings: [
        {
            id: null,
            ext_id: 'ext_id_1', // from Flow Providers' fee_types id
            name: "Sales",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 1,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_2', // from Flow Providers' fee_types id
            name: "Discount",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 2,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_3', // from Flow Providers' fee_types id
            name: "Service Charges",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 3,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_4', // from Flow Providers' fee_types id
            name: "Rounding",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 4,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_5', // from Flow Providers' fee_types id
            name: "Sales Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 5,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_6', // from Flow Providers' fee_types id
            name: "Discount Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 6,
                nature: FeeNature.EXPENSE,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_7', // from Flow Providers' fee_types id
            name: "Service Charges Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 7,
                nature: FeeNature.INCOME,
            },
        },
        {
            id: null,
            ext_id: 'ext_id_8', // from Flow Providers' fee_types id
            name: "Rounding Refund",
            account_id: null, // Mapping (bukku account id)
            flow_fee_type: {
                id: 8,
                nature: FeeNature.INCOME,
            },
        },
    ],
};
